import * as React from "react";
import { merge, $ } from "glamor";
import { IChoiceValue } from "./single-choice-cell-editor";
import { OrderedSet, Map } from "immutable";
import Checkbox from "@material-ui/core/Checkbox";
import { formatMessage } from "lib/globalize-util";
import { FormControlLabel } from "@material-ui/core";
import theme from "styles/theme";
import { PAPER_HEIGHT } from "./nu-rich-select-cell-editor";
import { NoAvailableOptions } from "./no-available-options";

interface IProps {
    [key: string]: any;
    availableValues: IChoiceValue[];
    delimiter?: string;
    checkedValues: OrderedSet<string>;
    onSelect: (id: string) => void;
    onSelectAll: () => void;
}

interface IState {
    possibleValues: Map<string, string>;
}

export class MultipleChoiceCellEditor extends React.PureComponent<IProps, IState> {
    private styles = merge(
        {
            minWidth: "220px",
            overflow: "scroll",
            maxHeight: "400px",
            minHeight: `${PAPER_HEIGHT}px`,
            width: this.props.eGridCell?.style.width,
        },
        $(" .checkboxLabel", { padding: "0px" }),
        $(" .MuiFormControlLabel-root", { marginLeft: "0px", display: "block" }),
        $(" .MuiCheckbox-colorSecondary.Mui-checked", {
            color: theme.palette.accent1Color,
        }),
        $(" .MuiTypography-body1", {
            fontSize: "1.4rem",
        })
    );

    constructor(props) {
        super(props);
        const { keyPress } = this.props;
    }

    handleCheckboxChange = (e) => {
        const { value } = e.target;
        this.props.onSelect(value);
    };

    handleSelectAll = (e) => {
        this.props.onSelectAll();
    };

    render() {
        const { checkedValues, availableValues } = this.props;
        return (
            <div {...this.styles}>
                {!!availableValues.length && (
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={checkedValues.size === availableValues.length}
                                onChange={this.handleSelectAll}
                            />
                        }
                        className="checkboxLabel"
                        label={formatMessage("All")}
                    />
                )}
                {!!availableValues.length && <hr />}
                {availableValues.length ? (
                    availableValues.map(({ label, id }) => (
                        <FormControlLabel
                            className="checkboxLabel"
                            key={id}
                            control={<Checkbox checked={checkedValues.has(id)} onChange={this.handleCheckboxChange} />}
                            label={formatMessage(label)}
                            value={id}
                        />
                    ))
                ) : (
                    <NoAvailableOptions />
                )}
            </div>
        );
    }
}
